import { render, staticRenderFns } from "./PrepTeamIcon.vue?vue&type=template&id=4fa22c62&scoped=true&"
import script from "./PrepTeamIcon.vue?vue&type=script&lang=js&"
export * from "./PrepTeamIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa22c62",
  null
  
)

export default component.exports